import { createFileRoute } from "@tanstack/react-router";
import { ClientCompanyProjectsPage } from "../../../../pages/clients-page/client-company-projects-page";

export const Route = createFileRoute("/_auth/_frame/clients/$companyId/projects")({
  component: ClientCompanyProjectsPage,
});
